import { render, staticRenderFns } from "./ForgotPasswordComponent.vue?vue&type=template&id=28f990a5&scoped=true&"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f990a5",
  null
  
)

export default component.exports